import React from 'react';
import { PortalOverlay, Pane } from '@leverege/ui-elements';
import classnames from 'classnames';
import Pair from './Pair';
import S from '../installGateway/InstallGateway.css';
import { pairTagToKey, unpairTagFromKey } from '../../util/Interface';
import { getCompanyAndLocationIdsFromUrl } from '../../../util/Url';
import { jsx as _jsx } from "react/jsx-runtime";
export default class KeyTagPairing extends React.Component {
  constructor(props) {
    super(props);
    const {
      context: {
        target
      }
    } = props;
    if (target && target[0]) {
      if (target[0].type === 'key') {
        this.targetKeyId = target[0].id;
      }
      if (target[0].type === 'tag') {
        this.targetTagId = target[0].id;
      }
    }
  }
  onChange = ({
    data,
    value,
    original
  }) => {
    this.setState({
      [data]: value
    });
    if (original) {
      if (data === 'keyId') {
        this.setState({
          keyDevice: original
        });
      } else if (data === 'tagId') {
        this.setState({
          tag: original
        });
      } else {
        this.setState({
          [data]: original
        });
      }
    }
  };
  onPair = async () => {
    const {
      context: {
        clientProps: {
          delegate
        }
      }
    } = this.props;
    const {
      tag,
      keyDevice
    } = this.state;
    try {
      const {
        companyId,
        locationId
      } = getCompanyAndLocationIdsFromUrl(delegate.getInterfaceUrl());
      await pairTagToKey({
        keyId: keyDevice.id,
        tagId: tag.id,
        locationId,
        companyId,
        force: true
      });
    } catch (err) {
      console.log(`Could not pair tag ${tag.id} with key ${keyDevice.id}:`, err);
      throw err;
    }
  };
  onUnpair = async () => {
    const {
      context: {
        clientProps: {
          delegate
        }
      }
    } = this.props;
    const {
      tag,
      keyDevice
    } = this.state;
    try {
      const {
        companyId,
        locationId
      } = getCompanyAndLocationIdsFromUrl(delegate.getInterfaceUrl());
      await unpairTagFromKey({
        keyId: keyDevice.id,
        locationId,
        companyId
      });
    } catch (err) {
      console.log(`Could not unpair tag ${tag.id} with key ${keyDevice.id}:`, err);
      throw err;
    }
  };
  render() {
    const {
      delegate,
      show,
      onClose,
      mobile
    } = this.props;
    return /*#__PURE__*/_jsx(PortalOverlay, {
      variant: "dialog",
      showBackground: true,
      escapeWillClose: false,
      clickWillClose: false,
      show: show,
      onClose: onClose,
      targetId: "fullScreen",
      animation: "slideFromBottom",
      position: mobile ? 'full' : 'center',
      children: /*#__PURE__*/_jsx(Pane, {
        variant: mobile ? 'pairingMobile' : 'pairing',
        className: classnames(mobile ? S.pairingContainerMobile : S.pairingContainer, S.pairing),
        children: /*#__PURE__*/_jsx(Pair, {
          ...this.props,
          onChange: this.onChange,
          actions: delegate,
          ...this.state,
          targetKeyId: this.targetKeyId,
          targetTagId: this.targetTagId,
          titleVariant: "dialogTitle",
          tagNetworkId: process.env.TAG_NETWORK_ID,
          onPair: this.onPair,
          onUnpair: this.onUnpair,
          onClose: onClose,
          systemId: delegate.systemId,
          titleIcon: "https://recovr-ui-assets.storage.googleapis.com/pair_action_icon.png"
        })
      })
    });
  }
}